import './active-operate.less';
import classnames from 'classnames';
import React, { useState } from 'react';
import { getOperateDirection, getOperateType, MoveListenerLevel, useMoveEventListener } from '@/framework';
import { useResizeCursor } from '@/utils/cursor-kit';
import type { ITouchKitEvent } from '@/utils/event-kit';
import { BaseLayerViewType, ResizeOperateType, type ILayerProps } from '@/version-types';
import { useLineOperate } from '../hooks/use-line-operate';

const ActiveOperate: React.FC<{
    layer: ILayerProps;
}> = React.memo(({ layer }) => {
    const [curOperateType, setCurOperateType] = useState<ResizeOperateType | null>(null);
    const lineOperate = useLineOperate();

    useMoveEventListener(
        (e: ITouchKitEvent) => {
            const operateType = getOperateType(e.target);
            const direction = getOperateDirection(e.target);
            if (e.isStart) {
                setCurOperateType(
                    operateType === BaseLayerViewType.RESIZE
                        ? direction || BaseLayerViewType.MOVE
                        : BaseLayerViewType.MOVE,
                );
            }

            if (operateType === BaseLayerViewType.RESIZE) {
                lineOperate.resize(e, layer, direction);
            }
            if (e.isEnd) {
                setCurOperateType(null);
            }
        },
        MoveListenerLevel.DEFAULT_LEVEL,
        'brush-line-operate-default',
    );

    const getOperateOpacity = (operateType: ResizeOperateType | null, type: ResizeOperateType) => {
        return {
            opacity: operateType ? (operateType === type ? 1 : 0) : 1,
        };
    };

    const { rotate } = layer;
    const cursor = useResizeCursor(rotate);

    return (
        <div className={classnames('operate__brush-line')}>
            <div
                className={classnames('resize', ResizeOperateType.LC, cursor.LC)}
                data-operate-type={BaseLayerViewType.RESIZE}
                data-direction={ResizeOperateType.LC}
                style={{ ...getOperateOpacity(curOperateType, ResizeOperateType.LC) }}
            ></div>
            <div
                className={classnames('resize', ResizeOperateType.RC, cursor.RC)}
                data-operate-type={BaseLayerViewType.RESIZE}
                data-direction={ResizeOperateType.RC}
                style={{ ...getOperateOpacity(curOperateType, ResizeOperateType.RC) }}
            ></div>
        </div>
    );
});

export default ActiveOperate;
